import axios from 'axios'
import { ElMessage } from 'element-plus'
// import { getToken } from '@/utils/auth'
import { handleToLogout } from '@/utils/router'
import * as Api from './index.js'

// 请求队列
const pendingMap = new Map()
// 自定义响应CODE
const RESPONSE_CODE = [0, 200, undefined, '0000_1', '0001_1', '0000_2', '0014_15', '0014_16', '0014_2', '1303005', '1303004']

Object.values(Api).forEach((ins) => {
  // ins.defaults.headers.common.authorization = 'Bearer f637de8c-25c0-4e4a-917a-5491e85c5650'
  ins.defaults.headers.common['x-business-header'] = 'szpx'
  ins.defaults.timeout = 5000000
  ins.defaults.validateStatus = (status) =>
    (status >= 200 && status < 300) || status === 304
  ins.interceptors.request.use(
    (config) => {
      const { cancelRepeatRequest } = ins.extra || {}
      removePending(config)
      cancelRepeatRequest && addPending(config)
      return config
    },
    (error) => {
      ElMessage.error(error.message || '请求：未知错误')
      return Promise.reject(error)
    }
  )
  ins.interceptors.response.use(
    (res) => {
      removePending(res.config)
      const vres = res.data
      if (typeof (vres) === 'string') return vres
      if (vres instanceof Blob) return vres
      if (RESPONSE_CODE.includes(vres.code)) {
        vres.headers = res.headers
        vres.config = res.config
        return vres
      } else {
        ElMessage.error(
          `${vres.code}: ${vres.message || vres.msg}` || '响应：未知错误'
        )
      }
      return Promise.reject(vres)
    },
    (error) => {
      error.config && removePending(error.config)
      const { showErrorMessage } = ins.extra || {}
      showErrorMessage && httpErrorStatusHandle(error)
      return Promise.reject(error)
    }
  )
})

/**
 * 生成唯一的每个请求的唯一key
 * @param {*} config
 * @returns
 */
function getPendingKey (config) {
  let { url, method, params, data } = config
  if (typeof data === 'string') data = JSON.parse(data)
  return [url, method, JSON.stringify(params), JSON.stringify(data)].join('&')
}

/**
 * 储存每个请求的唯一cancel回调, 以此为标识
 * @param {*} config
 */
function addPending (config) {
  const pendingKey = getPendingKey(config)
  config.cancelToken = config.cancelToken || new axios.CancelToken((cancel) => {
    if (!pendingMap.has(pendingKey)) {
      pendingMap.set(pendingKey, cancel)
    }
  })
}

/**
 * 删除重复的请求
 * @param {*} config
 */
function removePending (config) {
  const pendingKey = getPendingKey(config)
  if (pendingMap.has(pendingKey)) {
    const cancelToken = pendingMap.get(pendingKey)
    cancelToken(pendingKey)
    pendingMap.delete(pendingKey)
  }
}

/**
 * 错误信息处理
 */
function httpErrorStatusHandle (_error) {
  // 处理被取消的请求
  if (axios.isCancel(_error)) return console.error('请求的重复请求：' + _error.message)
  let message = ''
  if (_error && _error.response) {
    switch (_error.response.status) {
      case 302: message = '接口重定向了！'; break
      case 400: message = '参数不正确！'; break
      case 401:
        message = '登录状态已过期，请重新登录'
        handleToLogout()
        break
      case 403: message = '您没有权限操作！'; break
      case 404: message = `请求地址出错: ${_error.response.config.url}`; break
      case 408: message = '请求超时！'; break
      case 409: message = '系统已存在相同数据！'; break
      case 500: message = '服务器内部错误或登录失效！'; break
      case 501: message = '服务未实现！'; break
      case 502: message = '网关错误！'; break
      case 503: message = '服务不可用！'; break
      case 504: message = '服务暂时无法访问，请稍后再试！'; break
      case 505: message = 'HTTP版本不受支持！'; break
      default: message = '异常问题，请联系管理员！'; break
    }
  }
  if (_error.message.includes('timeout')) message = '网络请求超时！'
  if (_error.message.includes('Network')) message = window.navigator.onLine ? '服务端异常！' : '您断网了！'

  ElMessage({
    type: 'error',
    grouping: true,
    message
  })
}
